import { AvgEnergyCost } from '@/types'
import * as actions from '../actions/energy'
import { getApiErrorMessage } from '../utils/errorUtilities'
import { PayloadAction } from '@reduxjs/toolkit'

type State = {
  states: AvgEnergyCost[] | null
  isLoading: boolean
  errors: Record<string, unknown>
}

const initialState: State = {
  states: null,
  isLoading: false,
  errors: {},
}

export default (state = initialState, action: PayloadAction<any>): State => {
  switch (action.type) {
    case actions.ENERGY_STATES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        states: action.payload,
        errors: {},
      }
    case actions.ENERGY_STATES_REQUEST:
      return {
        ...state,
        isLoading: true,
      }
    case actions.ENERGY_STATES_FAILURE:
      return {
        ...state,
        isLoading: false,
        errors: getApiErrorMessage(action.payload),
      }
    default:
      return state
  }
}
